/* Common Imports */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */
import { Typography } from "@material-ui/core";

/* Data Imports */
import AppConfig from "../../../../AppConfig";

/* Define all styles */
const useStyles = makeStyles((theme) => ({
  iconTextRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
      width: "100%",
      gap: "0.5rem",
    },
    gap: "1rem",
    width: "25%",
    border: "1px solid #FFFFFF33",
    borderRadius: "1rem",
    // padding: "1rem",
  },
  text: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    gap: "0.5rem",
  },
  heading: {
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: "2rem",
    color: "#212121",
    width: "100%",
    padding: " 1rem 0rem 0rem 1rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.875rem",
      lineHeight: "1rem",
      color: "#212121",
    },
  },
  imageWrapper: {
    width: 140,
    height: 140,
    background: "#FFF7F8",
    borderRadius: "60px 16px 16px 0px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: " 0.5rem",
  },
  icon: {
    width: 110,
    height: 110,
    opacity: 1,
    objectFit: "contain",
    borderRadius: "60px 0px 0px 0px",
  },
}));

const AmenitiesIconCard = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={`${classes.iconTextRow} ${props.className}`}>
        <div className={classes.text}>
          <Typography
            variant="body2"
            component="span"
            className={classes.heading}
          >
            {props.title ? props.title : "Modern"}
          </Typography>
          <div className={classes.imageWrapper}>
            <img
              alt={AppConfig.imageAltText}
              loading="lazy"
              referrerPolicy="no-referrer"
              className={classes.icon}
              src={props.icon ? props.icon : "/images/icons/config/area.svg"}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AmenitiesIconCard;
